export enum ActiveScreenManager {
  CHROME = "chrome",
  EMAIL = "email",
  MEETING = "meeting",
}

export enum ItemType {
  EMAIL = "email",
  MEETING = "meeting",
  COMPANY = "company",
}

export enum Platform {
  CHROME = "chrome",
  OUTLOOK = "outlook",
}

export enum MetricsExtractionStatus {
  INITIAL = "Initial",
  UPLOADED = "Uploaded",
  BEING_PROCESSED = "Being Processed",
  FAILED = "Failed",
  EXTRACTED_ALL = "Extracted All",
  EXTRACTED_PARTIAL = "Extracted Partial",
  APPROVED = "Approved",
  CANCELLED = "Cancelled",
}

export enum DocumentType {
  IC_MEMO = "IC Memo",
  CIM = "CIM",
  DOCUMENT = "Document",
}

export enum DealStageStatus {
  ACTIVE = "Active",
  FINISHED = "Finished",
  STARTED = "Started",
  SHOWN_ON_PIPELINE = "Shown On Pipeline",
  NOT_SHOWN_ON_PIPELINE = "Not Shown On Pipeline",
  PORTFOLIO = "Portfolio",
}

export enum LastInteractionTypes {
  EMAIL = "email",
  MEETING = "meeting",
}

export type LastInteractedMeeting = {
  id: string;
  title: string;
  location: string;
  start_time: string;
  end_time: string;
};

export enum Source {
  CHROME_EXTENSION = "Chrome Extension",
  OUTLOOK_ADDIN = "Outlook Add-In",
}

export enum UnsubscribeOptions {
  UNSUBSCRIBE = "Unsubscribe from future emails",
  KEEP_THIS_EMAIL_ONLY = "Keep this email only",
  REMOVE_THREAD = "Remove the whole thread",
}

export enum PrimaryEntityOptions {
  DEAL = "deal",
  COMPANY = "company",
}
